import React from 'react';

const Loader = () => {
  return (
    <div className='typing-loader'>
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </div>);
};

export default Loader;


// WEBPACK FOOTER //
// ./src/screens/Profile/components/Loader.js